import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import UserContext from "../context/User";

function PrivateRoute({ children }) {
  const { isLoggedIn } = useContext(UserContext);
  const location = useLocation();

  if (!isLoggedIn)
    return (
      // The query string must live in `search`. React Router v6 throws on a
      // manually built `pathname` that contains "?", which crashed the page
      // for every guarded route the moment it was hit while signed out.
      <Navigate
        replace
        to={{
          pathname: "/login",
          search: `?redirect=${encodeURIComponent(location.pathname)}`,
        }}
        state={{ from: location.pathname }}
      />
    );
  return children;
}

export default PrivateRoute;
